import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useBrowserStorage } from '../../../../hooks/UseBrowserStorage';
import { useHomePageValuationLookup } from '../../../../features/landing/HomePageValuationLookup/HomePageValuationLookup.hook';
import { HOMEPAGE_VALUATION_LOOKUP } from '../../../../features/landing/HomePageValuationLookup/HomePageValuationLookup.typed';
import type { ValuationFormValues } from '../../../../components/CarValuationPage/components/ValuationTool/ValuationTool.schema';

const useValuationLookupForm = () => {
  const { setValue } = useFormContext<ValuationFormValues>();
  const { getLocalStorageItem } = useBrowserStorage();
  const { isHomePageValuationModalQueryPresent } = useHomePageValuationLookup();

  useEffect(() => {
    if (!isHomePageValuationModalQueryPresent) return;

    const formData: ValuationFormValues | null = getLocalStorageItem(
      HOMEPAGE_VALUATION_LOOKUP.KEY,
    );
    if (!formData) return;

    setValue('registration', formData.registration);
    setValue('mileage', formData.mileage);
    setValue('mileageType', formData.mileageType);
  }, [isHomePageValuationModalQueryPresent, setValue, getLocalStorageItem]);
};

export { useValuationLookupForm };
